import { Pipe, PipeTransform } from '@angular/core';
import { TimezoneService } from '../../core/services/timezone.service';

@Pipe({
  name: 'localDate',
  standalone: false,
})
export class LocalDatePipe implements PipeTransform {
  constructor(private readonly timezoneService: TimezoneService) {}

  transform(value: string | null | undefined, timezone?: string | null, locale = 'en-US'): string {
    const normalized = `${value || ''}`.trim();
    if (!normalized) {
      return '';
    }

    const resolvedTimezone = this.timezoneService.validateTimezone(timezone);
    const parsed = new Date(normalized);
    if (Number.isNaN(parsed.getTime())) {
      return normalized;
    }

    return new Intl.DateTimeFormat(locale, {
      timeZone: resolvedTimezone,
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      timeZoneName: 'short',
    }).format(parsed);
  }
}
